import { Badge, Box, IconButton } from "@chakra-ui/react"
import { FiMessageCircle } from "react-icons/fi"

interface FeedbackIconProps {
  feedbackCount?: number
  onClick: () => void
}

export function FeedbackIcon({
  feedbackCount = 0,
  onClick,
}: FeedbackIconProps) {
  // Determine color based on feedback count
  const hasMany = feedbackCount > 2
  const colorPalette = feedbackCount > 0 ? (hasMany ? "red" : "blue") : "gray"

  const title =
    feedbackCount === 0
      ? "Give feedback on this question"
      : feedbackCount === 1
        ? "1 feedback thread on this question"
        : `${feedbackCount} feedback threads on this question`

  return (
    <Box position="relative">
      <IconButton
        aria-label={title}
        title={title}
        size="sm"
        variant="ghost"
        colorPalette={colorPalette}
        onClick={onClick}
      >
        <FiMessageCircle />
      </IconButton>
      {feedbackCount > 0 && (
        <Badge
          position="absolute"
          top="-1"
          right="-1"
          colorPalette={colorPalette}
          borderRadius="full"
          fontSize="2xs"
          px={1.5}
          py={0.5}
          minW="18px"
          textAlign="center"
        >
          {feedbackCount}
        </Badge>
      )}
    </Box>
  )
}
